//****************************************************************************
//
// Copyright(C) 2025, CyberTAN Technology, Inc. All Rights Reserved.
// This source code contains confidential and proprietary
// information of CyberTAN Technology, Inc. Unauthorized reproduction,
// modification, distribution, or disclosure of this file, in whole or in part,
// by any means, is strictly prohibited without prior written permission from
// CyberTAN Technology, Inc.
//
// THIS SOURCE CODE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT.
//
// IN NO EVENT SHALL CYBERTAN TECHNOLOGY, INC. BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOURCE CODE.
//
//****************************************************************************

import { flexRender, Table } from '@tanstack/react-table';
import sortDown from 'assets/arrow-narrow-down.svg';
import sortUp from 'assets/arrow-narrow-up.svg';
import sort from 'assets/switch-vertical.svg';

const TableHeader = ({ table, columnWidthClassName }: { table: Table<any>; columnWidthClassName?: Record<string, string> }) => {
  return (
    <thead>
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => {
            return (
              <th
                key={header.id}
                colSpan={header.colSpan}
                className={`${header.id === 'remove' || header.id === 'edit' ? 'th-style' : ''} ${columnWidthClassName?.[header.column.id] ?? ''}`}
              >
                {header.isPlaceholder ? null : (
                  <>
                    <div
                      {...{
                        className: header.column.getCanSort() ? 'cursor-pointer select-none flex justify-center items-center' : '',
                        onClick: header.column.getToggleSortingHandler(),
                      }}
                    >
                      {flexRender(header.column.columnDef.header, header.getContext())}
                      {header.column.getCanSort() &&
                        ({
                          asc: <img src={sortUp} className="w-4 h-4 mx-1" alt="sortUp" />,
                          desc: <img src={sortDown} className="w-4 h-4 mx-1" alt="sortDown" />,
                        }[header.column.getIsSorted() as string] ?? <img src={sort} className="w-4 h-4 mx-1" alt="sort" />)}
                    </div>
                  </>
                )}
              </th>
            );
          })}
        </tr>
      ))}
    </thead>
  );
};

export default TableHeader;
